import React, { memo } from "react";
import { useSelector } from "react-redux";
import i18n from "utils/i18n";
import { dataConstants } from "services/redux/data/constants";
import Text from "theme/Text";
import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import Button from 'theme/Button'
import { SCAN_STATUS, useEmployeeScanStatus } from 'utils/objects/employee-scan'
import isEqual from 'react-fast-compare'
import VStack from "components/atoms/stack/VStack";

const ScanButton = ({ onPressScanInButton = null, onPressScanOutButton = null, loading = false, enabled = true }) => {
	
	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} ) // keep for refresh
	const { isScanningInEnabled, isScanningOutEnabled, isScanningEnabled, scanStatus } = useEmployeeScanStatus()
	
	if( !isScanningEnabled || !enabled ) {
		return null;
	}
	
	if( scanStatus !== SCAN_STATUS.SCANNED_IN && isScanningInEnabled ) {
		return (
			<VStack>
				<Text style={ styles.title }>{i18n.t( 'page.home.in_the_office')}</Text>
				
				<Button
					onPress={ onPressScanInButton }
					style={ styles.button }
					textStyle={ styles.buttonText }
					appearance="inverse"
					isLoading={ loading }>
					
					{ i18n.t( 'page.start.button_scan_in' ) }
				</Button>
			</VStack>
		)
	}
	
	if( scanStatus === SCAN_STATUS.SCANNED_IN && isScanningOutEnabled ) {
		return (
			<VStack>
				<Text style={ styles.title }>{i18n.t( 'page.home.left_the_office')}</Text>
				
				<Button
					onPress={ onPressScanOutButton }
					style={ styles.button }
					textStyle={ styles.buttonText }
					spinnerStatus={ 'primary' }
					isLoading={ loading }>
					
					{ i18n.t( 'page.start.button_scan_out' ) }
				</Button>
			</VStack>
		)
	}
	
	return (
		<Text style={ styles.title }>{ i18n.t( 'page.home.welcome_in_the_office') }</Text>
	)
}

const styles = StyleSheet.create({
	title: {
		color: colorList.WHITE.light,
		opacity: 0.9,
		fontSize: 14,
		fontWeight: '700',
		marginBottom: 12
	},
	button:{
		backgroundColor: colorList.WHITE.primary,
		marginBottom: 12,
	},
	buttonText: {
		color: colorList.ORANGE.primary
	}
});

export default memo( ScanButton, isEqual )
